import OLIGO_LOGO from './resource/oligo-logo.svg';
import LEB_LOGO from './resource/client-images/leb.png';
import MTS_LOGO from './resource/client-images/MTS-logo.png'
import TRINITY_LOGO from './resource/client-images/trinity-logo.jpg'
import LEXUS_LOGO from './resource/client-images/LEXUS-logo.jpg'
import ROX_GROWTH_LOGO from './resource/client-images/roxgrowth-logo.png'
import KNOX_LOGO from './resource/client-images/Knox-New-Logo.png'
import TRINITYKEW_LOGO from './resource/client-images/TrinityKew-logo.png'
import KMP_LOGO from './resource/client-images/KMP-logo.png'
import BENZ_LOGO from './resource/client-images/Benz-logo.png'
import OXLEY_LOGO from './resource/client-images/Oxley-logo.png'
import AU_BRIDGE_LOGO from './resource/client-images/AUBridge-logo.svg'
import CreditCardPaymentImageFour from './resource/creditCardPaymentImage-four.png';
import CreditCardPaymentImageTwo from "./resource/creditCardPaymentImage-two.png";
import CODEHQ_LOGO from './resource/client-images/CodeHQ-logo.jpg';
import HM_LOGO from './resource/client-images/HM-logo.png';
import Haidari_LOGO from './resource/client-images/Haidari-logo.jpeg';
import AMAL_LOGO from './resource/client-images/AMAL-logo.png';

const SANXBOX_TILL_PAYMENT_JS_SCRIPT = 'https://test-gateway.tillpayments.com/js/integrated/payment.1.3.min.js';
const PROD_TILL_PAYMENT_JS_SCRIPT = 'https://gateway.tillpayments.com/js/integrated/payment.1.3.min.js';

const getHost = () => {
  const hostname = window.location.hostname;
  const env = new URLSearchParams(window.location.search).get('env');

  if ((hostname === 'demo.oligo.com.au' || hostname === 'localhost') && env === 'prod') {
    return 'payments.oligo.com.au';
  }
  return hostname;
}

const getCurrentHostConfigOnClient = () => {
  const host = getHost();
  switch (host) {
    case 'localhost':
      return {
        tillPublicIntegrationKey: 'DzweW87slJ21gf2jmtkX', // sandbox
        pageTitle: 'Online Gateway Demo',
        isDevEnv: true,
        themeColor: '#A65AF6',
        overrideSurchargeRate: 0.015,
        verifyRecaptcha: true,
      }
    case 'demo.oligo.com.au':
      return {
        tillPublicIntegrationKey: 'DzweW87slJ21gf2jmtkX', // sandbox
        pageTitle: 'Online Gateway Demo',
        isDevEnv: true,
        themeColor: '#A65AF6',
        overrideSurchargeRate: 0.015,
        verifyRecaptcha: true,
      }
    case 'bpay.oligo.com.au':
      return {
        tillPublicIntegrationKey: 'CH4N1NaTCfsZONlkOUWG__t', // prod
        isDevEnv: false,
        themeColor: '#A65AF6',
        hideAlipayPlus: true,
        defaultPaymentMethod: 'tillPaymentJs',
        overrideSurchargeRate: 0.015,
      }
    case 'aub.oligo.com.au':
      return {
        tillPublicIntegrationKey: 'y3gblM8l6gVg1fgSlP7S__t', // prod
        pageTitle: 'AU Bridge Pty Ltd ABN 51 674 639 313',
        isDevEnv: false,
        pageHeroLogo: AU_BRIDGE_LOGO,
        themeColor: '#E20A0A',
        hideAlipayPlus: true,
        defaultPaymentMethod: 'tillPaymentJs',
      }
    case 'payments.oligo.com.au':
    case 'anotherdemo.oligo.com.au':
      return {
        tillPublicIntegrationKey: 'jSx8xgMTTQ0iWbsY7OJK__t', // prod
        pageTitle: 'Oligo Payments Pty Ltd ABN 33 680 598 029',
        isDevEnv: false,
        themeColor: '#A65AF6',
        defaultPaymentMethod: 'fiserv-ipg-card',
        overrideCreditCardPaymentImage: CreditCardPaymentImageFour,
      }
    case 'skc.oligo.com.au':
    case 'www.vidatennis.com.au':
      return {
        tillPublicIntegrationKey: 'DzweW87slJ21gf2jmtkX', // sandbox
        pageTitle: 'Trinity Grammar School - Kew',
        isDevEnv: false,
        overridePaymentJsScript: SANXBOX_TILL_PAYMENT_JS_SCRIPT,
        pageHeroLogo: TRINITY_LOGO,
        themeColor: '#009D52',
      }
    case 'melbtax.oligo.com.au':
      return {
        tillPublicIntegrationKey: 'jB1yRTAGmo7GCPjfrph4__t', // prod
        pageTitle: 'Melbourne Tax Solutions ABN 86 664 848 686',
        isDevEnv: false,
        hideAlipayPlus: false,
        defaultPaymentMethod: 'tillPaymentJs',
        pageHeroLogo: MTS_LOGO,
        themeColor: '#A65AF6',
        overrideSurchargeRate: 0.015, // need to be the same with server config
      }
    case 'lcb.oligo.com.au':
      return {
        tillPublicIntegrationKey: 's3F9ZhPX84AtVdPxpNXw__t', // prod
        pageTitle: 'LC Elite Basketball',
        overrideReferencePlaceholder: 'Child Name / Invoice No',
        isDevEnv: false,
        hideAlipayPlus: false,
        defaultPaymentMethod: 'tillPaymentJs',
        pageHeroLogo: LEB_LOGO,
        themeColor: '#EF7C31', // Red is #E20A0A
        overrideSurchargeRateByMethod: {
          'tillPaymentJs': 0,
          'alipay': 0.015,
        },
      }
    case 'lexusblackburn-sales.oligo.com.au':
      return {
        tillPublicIntegrationKey: '04w4iUXWPj6kxzih4ISc', // prod
        pageTitle: 'Lexus Blackburn - Sales Department',
        overrideReferencePlaceholder: 'Deal No / Name',
        isDevEnv: false,
        hideAlipayPlus: false,
        pageHeroLogo: LEXUS_LOGO,
        themeColor: '#E20A0A', // Red is #E20A0A
        overrideSurchargeRate: 0.008,
      }
    case 'lexusblackburn-service.oligo.com.au':
      return {
        tillPublicIntegrationKey: '04w4iUXWPj6kxzih4ISc', // prod
        pageTitle: 'Lexus Blackburn - Service Department',
        overrideReferencePlaceholder: 'Job Card No / Name',
        isDevEnv: false,
        hideAlipayPlus: false,
        pageHeroLogo: LEXUS_LOGO,
        themeColor: '#E20A0A', // Red is #E20A0A
      }
    case 'roxgrowth.oligo.com.au':
      return {
        tillPublicIntegrationKey: 'v794wo3QML3b1k8y1BbM__t', // prod
        pageTitle: 'ROX GROWTH - ABN 18 657 970 628',
        isDevEnv: false,
        hideAlipayPlus: true,
        defaultPaymentMethod: 'tillPaymentJs',
        pageHeroLogo: ROX_GROWTH_LOGO,
        themeColor: '#A65AF6',
        overrideCreditCardPaymentImage: CreditCardPaymentImageFour,
      }
    case 'knox.oligo.com.au':
      return {
        tillPublicIntegrationKey: 'CRKncbt1q0FwF6tsg8Hv__t', // prod
        pageTitle: 'The Knox School – Tuition Fees & Levy Payments',
        isDevEnv: false,
        hideAlipayPlus: false,
        defaultPaymentMethod: 'tillPaymentJs',
        pageHeroLogo: KNOX_LOGO,
        themeColor: '#000C55',
        overrideCreditCardPaymentImage: CreditCardPaymentImageFour,
      }
    case 'trinitykew.oligo.com.au': // https://trinity.vic.edu.au/enrolment/apply/tuition-fees/
      return {
        tillPublicIntegrationKey: 'k9DuaWp5oIBNdIMyHmio__t', // prod
        pageTitle: 'Trinity Grammar School - Kew',
        isDevEnv: false,
        defaultPaymentMethod: 'alipay',
        pageHeroLogo: TRINITYKEW_LOGO,
        themeColor: '#0F2707',
      }
    case 'kmp.oligo.com.au':
      return {
        tillPublicIntegrationKey: 'iXWpIosrkBlEZUc1hT4t__t', // prod
        pageTitle: 'KMP Associates',
        isDevEnv: false,
        hideAlipayPlus: true,
        pageHeroLogo: KMP_LOGO,
        themeColor: '#000000',
        overrideCreditCardPaymentImage: CreditCardPaymentImageFour,
      }
    case 'codehq.oligo.com.au':
      return {
        tillPublicIntegrationKey: 'xjZo9qtNEbJeLFLDSGxS__t', // prod
        pageTitle: 'Code HQ Building Consultancy',
        isDevEnv: false,
        hideAlipayPlus: true,
        defaultPaymentMethod: 'fiserv-ipg-card',
        pageHeroLogo: CODEHQ_LOGO,
        themeColor: '#000C55',
        overrideCreditCardPaymentImage: CreditCardPaymentImageFour,
      }
    case 'payto.oligo.com.au':
      return {
        tillPublicIntegrationKey: 'jSx8xgMTTQ0iWbsY7OJK__t', // prod
        pageTitle: 'Oligo PayTo Demo',
        isDevEnv: false,
        hideAlipayPlus: true,
      }
    case 'mbsilverstar.oligo.com.au':
      return {
        tillPublicIntegrationKey: 'DzweW87slJ21gf2jmtkX', // sandbox
        pageTitle: 'Silver Star Motors',
        isDevEnv: false,
        overridePaymentJsScript: SANXBOX_TILL_PAYMENT_JS_SCRIPT,
        hideAlipayPlus: false,
        pageHeroLogo: BENZ_LOGO,
        themeColor: '#000000',
      }
    case 'oxley.oligo.com.au':
      return {
        tillPublicIntegrationKey: 'Xm3OMjTh2RWhs1BTZcOv__t', // prod
        pageTitle: 'Oxley Christian College – Tuition Fees & Other Payments',
        isDevEnv: false,
        hideAlipayPlus: false,
        pageHeroLogo: OXLEY_LOGO,
        themeColor: '#0B2954',
      }
    case 'hm.oligo.com.au':
      return {
        tillPublicIntegrationKey: 'NINcbPEwjZOLmmScebSr__t', // prod
        pageTitle: 'Heidelberg Mowers',
        isDevEnv: false,
        hideAlipayPlus: true,
        defaultPaymentMethod: 'tillPaymentJs',
        pageHeroLogo: HM_LOGO,
        themeColor: '#009D52',
      }
    case 'sarafi-dandenong.oligo.com.au':
      return {
        tillPublicIntegrationKey: '',
        pageTitle: 'Sarafi Haidari - Dandenong VIC',
        isDevEnv: false,
        hideAlipayPlus: true,
        defaultPaymentMethod: 'fiserv-ipg-card',
        pageHeroLogo: Haidari_LOGO,
        themeColor: '#000C55',
        overrideCreditCardPaymentImage: CreditCardPaymentImageFour,
      }
    case 'amal-footscray.oligo.com.au':
      return {
        tillPublicIntegrationKey: '',
        pageTitle: 'AMAL Express - Footscray',
        isDevEnv: false,
        hideAlipayPlus: true,
        defaultPaymentMethod: 'fiserv-ipg-card',
        pageHeroLogo: AMAL_LOGO,
        themeColor: '#000C55',
        overrideCreditCardPaymentImage: CreditCardPaymentImageFour,
      }
    default:
      return {};
  }
}


export const getTillPublicIntegrationKey = () => getCurrentHostConfigOnClient().tillPublicIntegrationKey;

export const getTillPaymentJsScript = () => {
  const hostConfig = getCurrentHostConfigOnClient();
  if (hostConfig.overridePaymentJsScript) return hostConfig.overridePaymentJsScript;
  return hostConfig.isDevEnv ? SANXBOX_TILL_PAYMENT_JS_SCRIPT : PROD_TILL_PAYMENT_JS_SCRIPT;
}

export const getPageHeroLogo = () => getCurrentHostConfigOnClient().pageHeroLogo || OLIGO_LOGO;

export const getPageTitle = () => getCurrentHostConfigOnClient().pageTitle;

export const getReferencePlaceholder = () => getCurrentHostConfigOnClient().overrideReferencePlaceholder || 'Invoice No / Name';

export const shouldShowDevEnvPaymentOptions = () => getCurrentHostConfigOnClient().isDevEnv;

export const getThemeColor = () => getCurrentHostConfigOnClient().themeColor || '#A65AF6';

export const shouldHideAlipayPlus = () => getCurrentHostConfigOnClient().hideAlipayPlus;

const getSurchargeRate = (paymentMethod) => {
  const hostConfig = getCurrentHostConfigOnClient();
  if (hostConfig.overrideSurchargeRateByMethod && hostConfig.overrideSurchargeRateByMethod[paymentMethod]) {
    return hostConfig.overrideSurchargeRateByMethod[paymentMethod];
  }
  return hostConfig.overrideSurchargeRate || 0;
}
export const getDisplaySurchargeRate = (paymentMethod) => {
  // 'tillPaymentJs', 'alipay', 'alipay-dana', etc.
  const customSurchargeRate = getSurchargeRate(paymentMethod);
  if (customSurchargeRate === 0) return false;
  return `${(customSurchargeRate * 100).toFixed(2)}%`;
}

export const getDefaultPaymentMethod = () => getCurrentHostConfigOnClient().defaultPaymentMethod || false;

export const shouldVerifyRecaptcha = () => getCurrentHostConfigOnClient().verifyRecaptcha || true;

export const getCreditCardPaymentImage = () => {
  const hostConfig = getCurrentHostConfigOnClient();
  return hostConfig.overrideCreditCardPaymentImage || CreditCardPaymentImageTwo;
}
